import { useEffect, useState } from 'react';

export const useSecondsCountdown = (targetUnixTime: number = 0) => {
    const [secondsLeft, setSecondsLeft] = useState<number>();

    useEffect(() => {
        const updateSeconds = () => {
            const secondsLeft = targetUnixTime - Math.floor(Number(new Date()) / 1000);

            setSecondsLeft(Math.max(secondsLeft, 0));

            if (secondsLeft <= 0) {
                clearInterval(timer);
            }
        };

        const timer = setInterval(updateSeconds, 1000);

        return () => clearInterval(timer);
    }, [targetUnixTime]);

    return typeof secondsLeft === 'number'
        ? {
              num: secondsLeft,
              formatted: formatSeconds(secondsLeft),
          }
        : null;
};

const formatSeconds = (totalSeconds: number) => {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return [minutes, seconds].map((num) => num.toString().padStart(2, '0')).join(':');
};
